// API 베이스 URL - 환경변수에서 가져오거나 기본값 사용
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api/v1/hyundai-kiosk';

// 공통 헤더 설정
const getHeaders = () => {
  return {
    'Content-Type': 'application/json',
  };
};

// 공통 에러 처리
const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || `HTTP error! status: ${response.status}`);
  }
  return response.json();
};



// QR 코드 사용 후 통계 데이터 등록 API
export const registerQRCodeUsage = async (sessionId, deviceId = null) => {
  try {
    const requestBody = {
      events: [
        {
          deviceId: deviceId, // 클라이언트 팀 확인 필요
          sessionId: sessionId,
          type: "QR",
          scanTimestamp: new Date().toISOString()
        }
      ],
    };

    // iOS Safari 호환성을 위해 sendBeacon 사용
    if (navigator.sendBeacon) {
      console.log('sendBeacon을 사용하여 QR 코드 사용 통계 전송');
      const blob = new Blob([JSON.stringify(requestBody)], { type: 'application/json' });
      const success = navigator.sendBeacon(`${API_BASE_URL}/events/sessions`, blob);
      
      if (success) {
        console.log('QR 코드 사용 통계가 성공적으로 전송되었습니다 (sendBeacon)');
        return { success: true, method: 'sendBeacon' };
      } else {
        console.warn('sendBeacon 전송 실패, fetch로 재시도');
      }
    }

    // sendBeacon이 실패하거나 지원되지 않는 경우 fetch 사용
    console.log('fetch를 사용하여 QR 코드 사용 통계 전송');
    const response = await fetch(`${API_BASE_URL}/events/sessions`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(requestBody)
    });

    return await handleResponse(response);
  } catch (error) {
    console.error('QR 코드 사용 통계 등록 실패:', error);
    throw error;
  }
};

// 오픈톡 클릭 후 데이터 저장 API
export const registerOpenTalkClick = async (sessionId) => {
  try {
    const requestBody = {
      events: [
        {
          // deviceId: deviceId, // 오픈톡에 추가 가능한지 클라이언트 팀 확인 필요
          sessionId: sessionId,
          type: "TALK",
          clickTimestamp: new Date().toISOString()
        }
      ],
    };

    // iOS Safari 호환성을 위해 sendBeacon 사용
    if (navigator.sendBeacon) {
      console.log('sendBeacon을 사용하여 오픈톡 클릭 데이터 전송');
      const blob = new Blob([JSON.stringify(requestBody)], { type: 'application/json' });
      const success = navigator.sendBeacon(`${API_BASE_URL}/events/interactions`, blob);
      
      if (success) {
        console.log('오픈톡 클릭 데이터가 성공적으로 전송되었습니다 (sendBeacon)');
        return { success: true, method: 'sendBeacon' };
      } else {
        console.warn('sendBeacon 전송 실패, fetch로 재시도');
      }
    }

    // sendBeacon이 실패하거나 지원되지 않는 경우 fetch 사용
    console.log('fetch를 사용하여 오픈톡 클릭 데이터 전송');
    const response = await fetch(`${API_BASE_URL}/events/interactions`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(requestBody)
    });

    return await handleResponse(response);
  } catch (error) {
    console.error('오픈톡 클릭 데이터 저장 실패:', error);
    throw error;
  }
};
